<template>
  <div>
    <div class="info-box">
      <div class="title-box">
        <p>助学金发放台账</p>
      </div>

      <div class="info-content">
        <div class="set-box">
          <el-col :span="24">
            <el-row>
              <el-col :span="24">
                <WtDataList
                  v-model="data.list"
                  :url="$url.support.taizhang"
                  :pageSize="10"
                  :isPages="true"
                  :search="search"
                  ref="supportTables"
                >
                  <div slot="list" style="padding:0 0 20px 0;">
                    <el-table
                      :data="data.list"
                      style="width: 100%"
                      ref="table"
                      @expand-change="expandChange"
                      @selection-change="handleSelectionChange"
                    >
                      <el-table-column type="expand">
                        <template slot-scope="scope">
                          <el-row>
                            <el-col :span="24" style="margin-top:10px;">
                              <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                  <span>助学金发放台账明细</span>
                                </div>
                                <div class="info-content" style="padding-bottom:0">
                                  <el-row :gutter="16" style="width:100%">
                                    <el-col :span="24">
                                      <el-card class="box-card">
                                        <el-input
                                          placeholder="学生姓名"
                                          v-model="esearch[0].user_name"
                                          clearable
                                          style="width: 170px"
                                        ></el-input>

                                        <el-select
                                          v-model="esearch[0].estatus"
                                          placeholder="提现情况"
                                          clearable
                                          style="width: 160px"
                                        >
                                          <el-option :value="9" label="未提现"></el-option>
                                          <el-option :value="1" label="提现成功"></el-option>
                                          <el-option :value="2" label="提现申请中"></el-option>
                                          <el-option :value="3" label="提现失败"></el-option>
                                        </el-select>

                                        <el-button
                                          type="primary"
                                          icon="el-icon-search"
                                          @click="msearch"
                                        >搜索</el-button>

                                        <el-dropdown style="float:right">
                                          <el-button type="primary" :disabled="infoDisabled" @click="exportFile(scope.row.batch_id)">
                                            导出台账明细
                                          </el-button>
                                        </el-dropdown>
                                      </el-card>
                                    </el-col>
                                  </el-row>
                                </div>
                                <WtDataList
                                  v-model="data.moneyList"
                                  :url="$url.support.mingxi"
                                  :pageSize="10"
                                  :isPages="true"
                                  :search="moneySearch"
                                  ref="moneyTables"
                                >
                                  <div class="profile-header" slot="list">
                                    <el-table
                                      :data="data.moneyList"
                                      style="width: 100%"
                                      ref="makeLoansTable"
                                    >
                                      <el-table-column label="姓名" width="80" prop="user_name"></el-table-column>
                                      <el-table-column label="入学时间" width="90" prop="entrance_date"></el-table-column>
                                      <el-table-column
                                        label="发放时间"
                                        minWidth="120"
                                        prop="created_at"
                                        align="center"
                                      ></el-table-column>
                                      <el-table-column
                                        label="发放金额"
                                        width="120"
                                        prop="amount"
                                        align="right"
                                      ></el-table-column>
                                      <el-table-column label="提现情况" width="120" align="center">
                                        <template slot-scope="scope">
                                          <div
                                            v-if="scope.row.estatus == 1"
                                            style="color:green"
                                          >提现成功</div>
                                          <div
                                            v-else-if="scope.row.estatus == 2"
                                            style="color:sandybrown"
                                          >提现申请中</div>
                                          <div
                                            v-else-if="scope.row.estatus == 3"
                                            style="color:red"
                                          >提现失败</div>
                                          <div v-else>未提现</div>
                                        </template>
                                      </el-table-column>
                                      <el-table-column
                                        label="提现时间"
                                        minWidth="120"
                                        prop="ecreated_at"
                                      ></el-table-column>
                                      <el-table-column label="错误原因" width="100" prop="retMsg"></el-table-column>
                                    </el-table>
                                  </div>
                                </WtDataList>
                              </el-card>
                            </el-col>
                          </el-row>
                        </template>
                      </el-table-column>
                      <el-table-column label="发放批次" width="150" prop="batch"></el-table-column>
                      <el-table-column label="描述" minWidth="200" prop="title"></el-table-column>
                      <el-table-column label="发放总金额" width="150" prop="ff_total" align="right"></el-table-column>
                      <el-table-column label="发放总人数" width="130" prop="ff_count" align="center"></el-table-column>
                      <el-table-column label="已提现人数" width="130" prop="e_count" align="center"></el-table-column>
                      <el-table-column label="已提现金额" width="150" prop="e_total" align="right"></el-table-column>
                    </el-table>
                  </div>
                </WtDataList>
              </el-col>
            </el-row>
          </el-col>
        </div>
      </div>
    </div>
    <el-dialog title="导入失败信息" :visible.sync="failVisible" width="50%">
      <el-table :data="failData" style="width: 100%" ref="failtable">
        <el-table-column label="学生姓名" width="100" prop="name"></el-table-column>
        <el-table-column label="身份证号码" width="180" prop="card_no"></el-table-column>
        <el-table-column label="失败原因" prop="msg"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="failVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getToken, setToken } from "@/libs/util";
import { mapActions, mapMutations } from "vuex";
import API from "@/libs/api_dispatch";
import { isvalidCardNo } from "@/libs/validate";
export default {
  data() {
    var validCardNo = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入学生身份证号码"));
      } else if (!isvalidCardNo(value)) {
        callback(new Error("请输入正确的学生身份证号码"));
      } else {
        callback();
      }
    };
    return {
      headers: {
        Authorization: "Bearer " + getToken()
      },
      sexList: [],
      nationList: [],
      gradeList: [],
      auditStatusList: [],
      abStatusList: [],
      show: false,
      multipleSelection: null,
      importNotify: null,
      infoDisabled: false,
      auditDataModal: {
        ab_status: 2,
        ids: []
      },
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      radio: 3,
      dialogVisible: false,
      editBankVisible: false,
      editUserVisible: false,
      failVisible: false,
      failData: [],
      data: {},
      search: {},
      esearch: [
        {
          user_name: "",
          estatus: ""
        }
      ],
      moneySearch: {},
      bankData: {},
      userData: {},
      navStatus: 1,
      rules: {
        card_holder_name: [
          { required: true, message: "请输入持卡人姓名", trigger: "blur" }
        ],
        bank_name: [
          { required: true, message: "请输入开户银行名称", trigger: "blur" }
        ],
        bank_no: [
          { required: true, message: "请输入银行卡号", trigger: "blur" }
        ],
        bank_address: [
          { required: true, message: "请输入开户银行所在城市", trigger: "blur" }
        ],
        bank_branch: [
          { required: true, message: "请输入开户银行详细地址", trigger: "blur" }
        ]
      },
      userRules: {
        user_name: [
          { required: true, message: "请输入学生姓名", trigger: "blur" }
        ],
        sex: [{ required: true, message: "请选择学生性别", trigger: "change" }],
        nation: [
          { required: true, message: "请选择学生所属民族", trigger: "change" }
        ],
        card_no: [{ required: true, validator: validCardNo, trigger: "blur" }],
        grade: [
          { required: true, message: "请选择学生所在年级", trigger: "change" }
        ],
        class: [
          { required: true, message: "请输入学生所在班级", trigger: "blur" }
        ],
        if_record: [
          { required: true, message: "请选择是否建档立卡户", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    /**
     * 引入函数
     */
    ...mapActions(["getDictList", "getNations"]),
    expandChange(row, expandedRows) {
      if (expandedRows.length) {
        this.esearch[0].user_name = "";
        this.esearch[0].estatus = "";
        //展开时，查询学生的助学金发放记录
        this.moneySearch.batch_id = row.batch_id;
        this.moneySearch.isStudent = 1;
      }
    },
    msearch() {
      this.moneySearch.user_name = this.esearch[0].user_name;
      this.moneySearch.estatus = this.esearch[0].estatus;
      console.log(this.moneySearch);
      this.$refs.moneyTables.handleSearch();
    },
    editBank(id) {
      //根据user_id查询对应的开户信息
      this.$db.get(this.$url.application.url + "/" + id).then(resp => {
        this.bankData = resp.data;
        this.editBankVisible = true;
      });
    },
    editUserInfo(user_id) {
      //根据user_id查询对应的用户信息
      this.$db.get(this.$url.user.support.url + "/" + user_id).then(resp => {
        this.userData = resp.data;
        console.log(resp.data, "data");
        this.editUserVisible = true;
      });
    },
    editUserDataSubmit() {
      let self = this;
      this.$refs.userForm.validate(valid => {
        if (valid) {
          self.$db.put(self.$url.user.support.ed, self.userData).then(resp => {
            if (resp && resp.data) {
              this.$notify({
                title: "提示信息",
                message: "学生信息编辑成功",
                type: "success"
              });
              this.editUserVisible = false;
              this.$refs.supportTables.reloadTable();
            }
          });
        } else {
          return false;
        }
      });
    },
    editBankDataSubmit() {
      let self = this;
      this.$refs.bankForm.validate(valid => {
        if (valid) {
          self.$db
            .put(
              self.$url.application.url + "/" + self.bankData.id,
              self.bankData
            )
            .then(resp => {
              if (resp && resp.data) {
                this.$notify({
                  title: "提示信息",
                  message: "银行卡信息编辑成功",
                  type: "success"
                });
                this.editBankVisible = false;
                this.$refs.supportTables.reloadTable();
              }
            });
        } else {
          return false;
        }
      });
    },
    handleSelectionChange(val) {
      let ids = [];
      val.forEach(element => {
        ids.push(element.id);
      });
      this.multipleSelection = ids;
    },
    exportFile(batch_id) {
      let notify = this.$notify({
        title: "提示",
        message: "信息正在导出，请稍等..",
        showClose: false,
        duration: 0
      });
      this.infoDisabled = true;
      //导出学生名录
      API.exportExcel(
        this.$url.support.studentExport,
        "post",
        this.moneySearch
      ).then(resp => {
        var blob = new Blob([resp], {
          type: "application/vnd.ms-excel;charset=utf-8"
        });
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = "顺丰莲花助学助学金发放台账.xlsx"; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
        notify.close();
        this.infoDisabled = false;
      });
    },
    handleClick() {
      let notify = this.$notify({
        title: "提示",
        message: "信息正在导出，请稍等..",
        showClose: false,
        duration: 0
      });
      this.infoDisabled = true;
      if (this.multipleSelection) {
        this.search.ids = this.multipleSelection;
      }
      //导出学生名录
      API.exportExcel(
        this.$url.application.user.export,
        "post",
        this.search
      ).then(resp => {
        var blob = new Blob([resp], {
          type: "application/vnd.ms-excel;charset=utf-8"
        });
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = "顺丰莲花助学资助学生信息确认名录.xlsx"; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
        notify.close();
        this.infoDisabled = false;
        this.search.ids = null;
        this.multipleSelection = null;
      });
    },
    success(response, file, fileList) {},
    bankProgress() {
      this.importNotify = this.$notify({
        title: "提示",
        message: "信息正在导入中，请稍等...",
        showClose: false,
        duration: 0
      });
    },
    studentError(err, file, fileList) {},
    studentSuccess(response, file, fileList) {
      this.importNotify.close();
      if (response.code == 200) {
        this.$notify({
          title: "提示信息",
          message: "新生信息导入成功",
          type: "success"
        });
        this.$refs.supportTables.reloadTable();
        if (response.data.fail_num > 0) {
          this.failData = response.data.fail_list;
          this.failVisible = true;
        }
      } else {
        this.$notify({
          title: "提示信息",
          message: "导入失败：" + response.msg,
          type: "error"
        });
      }
      this.$refs.uploads.clearFiles();
    },
    bankSuccess(response, file, fileList) {
      this.importNotify.close();
      if (response.code == 200) {
        this.$notify({
          title: "提示信息",
          message: "银行卡确认信息导入成功",
          type: "success"
        });
        this.$refs.supportTables.reloadTable();
        if (response.data.fail_num > 0) {
          this.failData = response.data.fail_list;
          this.failVisible = true;
        }
        this.$refs.uploads.clearFiles();
      }
    },
    toogleExpand(row) {
      let $table = this.$refs.table;
      $table.toggleRowExpansion(row, false);
    },
    handleEdit(data) {
      this.auditDataModal.ids.push(data.id);
      this.dialogVisible = true;
    },
    getNav(id) {
      this.navStatus = id;
      this.$router.push({ name: "centerHomeIndex" });
    },
    auditDataSubmit() {
      let self = this;
      self.$db
        .post(self.$url.user.support.ab, self.auditDataModal)
        .then(resp => {
          if (resp) {
            this.$notify({
              title: "提示信息",
              message: "学生就读状态维护成功",
              type: "success"
            });
            //刷新窗口
            self.$refs.supportTables.reloadTable();
            self.dialogVisible = false;
          }
          self.auditDataModal.ab_status = 2;
          self.auditDataModal.ab_reason = "";
          self.auditDataModal.ids = [];
        });
    }
  },
  mounted() {
    //查询对应的网站设置信息
    this.$db.post(this.$url.website.list).then(resp => {
      let data = resp.data[0];
      this.show = data.student == 1 ? true : false;
    });
    this.getDictList()
      .then(dictList => {
        this.sexList = dictList.sex;
        this.gradeList = dictList.grade;
        this.auditStatusList = dictList.apply_audit_status;
        this.abStatusList = dictList.ab_status;
      })
      .then(resp => {
        //民族缓存
        this.getNations().then(resp => {
          this.nationList = resp;
        });
      });
  }
};
</script>


<style lang="scss" scoped>
.profile-position {
  padding: 5px 0;
  color: #515a6e;
}
.info-box {
  margin-top: 4.0740740740740744vh;
  .title-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    > p {
      color: #414c60;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
    > h5 {
      font-weight: normal;
      color: #8d95a4;
      font-size: 2.2222222222222223vh;
      line-height: 2.2222222222222223vh;
    }
  }
  .info-content {
    display: flex;
    justify-content: space-between;
    margin-top: 1.6666666666666666vh;
    padding-bottom: 4.351851851851852vh;
    .list-box {
      height: 19.518518518518517vh;
      width: 10.416666666666667vw;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      .list-time {
        height: 13.796296296296295vh;
        border-bottom: 1px solid #e4e5e9;
        overflow: hidden;
        > p {
          color: #414c60;
          font-size: 3.333333333333333vh;
          text-align: center;
          margin-top: 4.814814814814815vh;
          > span {
            color: #414c60;
            font-size: 1.6666666666666666vh;
            line-height: 1.6666666666666666vh;
          }
        }
        > i {
          display: block;
          width: 100%;
          font-style: normal;
          color: #8d95a4;
          font-size: 1.4814814814814815vh;
          // margin-top: 0.7259259259259259vh;
          text-align: center;
        }
      }
      .list-top {
        height: 13.796296296296295vh;
        border-bottom: 1px solid #e4e5e9;
        > p {
          color: #414c60;
          font-size: 3.333333333333333vh;
          line-height: 13.796296296296295vh;
          text-align: center;

          > span {
            color: #414c60;
            font-size: 1.6666666666666666vh;
            line-height: 1.6666666666666666vh;
          }
        }
        > h5 {
          font-weight: normal;
          color: #414c60;
          font-size: 2.2222222222222223vh;
          line-height: 13.796296296296295vh;
          text-align: center;
        }
      }
      .list-bottom {
        height: 4.6296296296296294vh;
        position: relative;
        > p {
          color: #8d95a4;
          font-size: 1.4814814814814815vh;
          line-height: 1.4814814814814815vh;
          padding-left: 0.7291666666666667vw;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          > span {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #1caee0;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
    }
    .set-box {
      //height: 19.518518518518517vh;
      //width: 30.833333333333335vw;
      width: 100%;
      padding: 15px;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      display: flex;
      justify-content: space-between;
      .set-info {
        padding-left: 9.895833333333333vw;
        height: 100%;
        position: relative;
        overflow: hidden;
        > img {
          width: 12.407407407407407vh;
          height: 12.407407407407407vh;
          border-radius: 50%;
          overflow: hidden;
          position: absolute;
          left: 1.8229166666666668vw;
          top: 50%;
          transform: translateY(-50%);
        }
        > h5 {
          font-weight: normal;
          color: #414c60;
          font-size: 2.2222222222222223vh;
          line-height: 2.2222222222222223vh;
          margin-top: 5.185185185185185vh;
          margin-bottom: 1.5370370370370372vh;
        }
        > p {
          color: #8d95a4;
          font-size: 1.6666666666666666vh;
          line-height: 1.6666666666666666vh;
          margin-bottom: 1.2962962962962963vh;
        }
      }
      .set-btn {
        margin-right: 3.958333333333333vw;
        overflow: hidden;
        > h5 {
          font-weight: normal;
          font-size: 3.333333333333333vh;
          color: #1caee0;
          margin-top: 6.111111111111111vh;
        }
        > p {
          color: #1caee0;
          font-size: 1.4814814814814815vh;
          margin-top: 0.8407407407407408;
          text-align: center;
        }
      }
    }
  }
}
.c-bottom {
  display: flex;
  justify-content: space-between;
  .public-box {
    //width: 38.54166666666667vw;
    width: 100%;
    padding-bottom: 6.066666666666667vh;
    .public-title {
      display: flex;
      justify-content: space-between;
      width: 100%;
      > p {
        color: #414c60;
        font-size: 2.2222222222222223vh;
        line-height: 2.2222222222222223vh;
      }
      > h5 {
        font-weight: normal;
        color: #8d95a4;
        font-size: 2.2222222222222223vh;
        line-height: 2.2222222222222223vh;
      }
    }
    .train-box {
      width: 100%;
      //height: 44.44444444444444vh;
      box-shadow: 0px 0px 20px 0px rgba(0, 1, 3, 0.1);
      border-radius: 0.5555555555555556vh;
      margin-top: 1.6666666666666666vh;
      border: solid 1px #e6e7eb;
      overflow: hidden;
      .train-top {
        width: 100%;
        height: 34.16666666666667vh;
        > ul {
          padding: 4.6296296296296294vh 2.1875vw;
          > li {
            list-style: none;
            display: flex;
            margin-bottom: 5.3703703703703705vh;
            &:last-child {
              margin-bottom: 0;
            }
            .left-box {
              height: 4.4444444444444446vh;
              width: 5vw;
              border-right: 1px solid #e4e5e9;
              > h5 {
                font-weight: normal;
                color: #bfc0c8;
                font-size: 2.7777777777777776vh;
                line-height: 2.7777777777777776vh;
              }
              > p {
                font-size: 1.4814814814814815vh;
                color: #bfc0c8;
              }
            }
            .right-box {
              padding-left: 1.5625vw;
              //width: 26.666666666666666vw;
              > h5 {
                color: #414c60;
                font-size: 1.6666666666666666vh;
                line-height: 1.6666666666666666vh;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
                margin-bottom: 1.0037037037037037vh;
              }
              > p {
                color: #8d95a4;
                font-size: 1.2962962962962963vh;
                // line-height: 1.2962962962962963vh;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
              }
            }
          }
        }
      }
      .term-box {
        width: 100%;
        height: 34.16666666666667vh;
        > ul {
          padding: 4.6296296296296294vh 2.1875vw;
          li {
            list-style: none;
            display: flex;
            margin-bottom: 5vh;
            &:last-child {
              margin-bottom: 0;
            }
            > p {
              width: 4.0625vw;
              height: 2.3148148148148147vh;
              border-right: 1px solid #e4e5e9;
              font-size: 2.2222222222222223vh;
              line-height: 2.3148148148148147vh;
              color: #bfc0c8;
            }
            .score-box {
              width: 29.635416666666664vw;
              display: flex;
              justify-content: space-between;
              padding-left: 1.3020833333333334vw;
              > h5 {
                color: #414c60;
                font-size: 1.6666666666666666vh;
                line-height: 2.3148148148148147vh;
              }
              > p {
                > span {
                  font-size: 2.3666666666666666vh;
                  line-height: 2.3148148148148147vh;
                  color: #414c60;
                }
              }
            }
          }
        }
      }
      .train-bottom {
        height: 10.092592592592593vh;
        background-color: #1caee0;
        position: relative;
        > p {
          font-size: 2.2222222222222223vh;
          color: #fff;
          font-weight: 600;
          padding-left: 3.4895833333333334vw;
          line-height: 4.6296296296296294vh;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          > span {
            width: 4.6296296296296294vh;
            height: 4.6296296296296294vh;
            border-radius: 50%;
            background-color: #fff;
            color: #1caee0;
            font-size: 4.2222222222222223vh;
            line-height: 4.6296296296296294vh;
            text-align: center;
            position: absolute;
            left: 0;
            top: 0;
            font-weight: 100;
          }
          > i {
            font-style: normal;
            width: 4.6296296296296294vh;
            height: 4.6296296296296294vh;
            border-radius: 50%;
            background-color: #fff;
            color: #feb64d;
            font-size: 2.2222222222222223vh;
            line-height: 4.6296296296296294vh;
            text-align: center;
            position: absolute;
            left: 0;
            top: 0;
            font-weight: 100;
          }
        }
      }
    }
  }
}
</style>

<style scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.user-profile-name {
  display: inline-block;
  font-size: 22px;
  font-weight: 500;
  padding: 0px 15px;
}
.user-profile-tab {
  margin-top: 15px;
  padding: 0px 15px;
}
.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.contact-information,
.basic-information {
  margin: 10px 0px;
}
.contact-title {
  display: inline-block;
  padding-bottom: 15px;
  width: 170px;
  font-size: 16px;
  color: #868e96;
}
.phone-number,
.mail-address,
.contact-email,
.contact-website,
.contact-skype,
.birth-date,
.gender {
  font-size: 16px;
  color: #373757;
}

.section-body {
  overflow: hidden;
  box-shadow: 0 1px 2px transparent, 0 1px 4px rgba(0, 0, 0, 0.3);
  transition: All 0.5s ease;
  padding: 10px;
  margin-bottom: 25px;
}
.profile-right-section .section-body {
  margin-bottom: 5px;
}
.profile-right-section ul {
  margin-bottom: 0;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 10px 15px;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid #ddd;
}
.list-group .list-group-item:first-child {
  border-radius: 0;
}
.profile-right-section ul li h3 {
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}

.text-primary {
  color: #4390ff !important;
}
.profile-right-section ul li p {
  padding-bottom: 5px;
}
.profile-left-section .profile-title {
  font-size: 17px;
  font-weight: 500;
  margin-bottom: 5px;
  text-transform: uppercase;
}
.list-group-item img {
  width: 90px;
  height: 80px;
  margin: 0 5px 5px;
  vertical-align: middle;
}
</style>
<style scoped>
.el-input,
.el-select,
ivu-cascader,
.ivu-select {
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/Center/user/studentAccounts.vue